import { FormControl, FormHelperText, FormLabel } from "@mui/material";
import { Control, FieldPath, FieldValues, useController } from "react-hook-form";
import { isDefined } from "@clipboard-health/util-ts";
import { ReactNode } from "react";

interface FormFieldControllerProps<TFormValues extends FieldValues> {
  name: FieldPath<TFormValues>;
  control: Control<TFormValues>;
  label: ReactNode;
  hideLabel?: boolean;
  hideHelperText?: boolean;
  render: (field: FieldValues) => ReactNode;
  required?: boolean;
}

export function FormFieldController<TFormValues extends FieldValues>(
  props: FormFieldControllerProps<TFormValues>
) {
  const {
    name,
    control,
    label,
    hideLabel = false,
    hideHelperText = false,
    render,
    required,
  } = props;
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  return (
    <FormControl fullWidth>
      <FormLabel htmlFor={name} hidden={hideLabel} required={required}>
        {label}
      </FormLabel>
      {render(field)}
      <FormHelperText
        hidden={hideHelperText}
        sx={{
          height: "1rem",
          marginLeft: 0,
        }}
        error={isDefined(error)}
      >
        {error?.message}
      </FormHelperText>
    </FormControl>
  );
}
